import { SelectValue, ParamsFormatter, LabelFormatter } from './types';

export const exists = (value: SelectValue) => value !== null

export const defaultParamsFormatter: ParamsFormatter = (value, id) => value ? `filters[0][id]=${id}&filters[0][value]=${value}` : '';

export const defaultLabelFormatter: LabelFormatter<any> = (value, name) => value[name];
